import axiosClient from './axiosClient';

const authController = {
  activateUser(token, activateToken, password) {
    const url = '/api/noauth/activate?sendActivationMail=false';
    const payload = {
      activateToken: activateToken,
      password: password,
    };
    return axiosClient.post(url, payload, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
};

export default authController;
